module.exports = __webpack_public_path__ + "static/nerd-face-min-d49e82470a316192365fc2438ba59ea5.png";